// axios
import axios from 'axios'
import store from "@/store/store";
import router from "@/router";

const baseURL = process.env.VUE_APP_API_SERVER_URL

const token = localStorage.getItem('user-token')

const api = axios.create({
    baseURL,
    headers:{
        Authorization: 'Token '+token
    }
});

api.interceptors.response.use((response) => {
        return response;
    }, (error) => {

        if(error.response.status === 401){
            store.dispatch("AUTH_LOGOUT")
        }
        // console.log(Promise.reject(error))
        return Promise.reject(error);

        // return error.response;
    });

export default api
